import microuniversoApi from "app/api/microuniversoApi"
import globalMU from "globalMU"
import React from "react"
import { AlterarSenhaVendedor } from "./AlterarSenhaVendedor"

export type AlterarSenhaVendedorContainerProps = {
    onCancelar: () => void
    onSenhaAlterada: () => void
}

export const AlterarSenhaVendedorContainer = (props: AlterarSenhaVendedorContainerProps) => {
    return <>
        <AlterarSenhaVendedor
            onCancelar={props.onCancelar}
            onNovaSenhaInformada={async (senhaAtual, novaSenha, confirmacaoSenha) => {
                if (novaSenha != confirmacaoSenha) {
                    globalMU.showErrorMessage(`Confirmação de senha não confere com a senha informada`)
                    return
                }
                
                const resposta = await microuniversoApi.Vendedor.alterarSenha(senhaAtual, novaSenha)

                if (resposta != null && "HasErrors" in resposta) {
                    return
                }

                globalMU.showSuccessMessage(`Alteração de senha confirmada`)

                props.onSenhaAlterada()

            }}/>
    </>
}